// extracted by mini-css-extract-plugin
export default {"jobList":"style_jobList__i-Wv4","jobCard":"style_jobCard__eucoA","app_container":"style_app_container__7LZSG","mobile_app_container":"style_mobile_app_container__G8lGM"};